module.exports = __webpack_public_path__ + "static/media/18ECA24.aad849bb.jpg";